import {Rating} from '../starRating/rating';
import {GoogleCaptcha} from '../captcha/GoogleCaptcha';
import {Api} from '../api/api';
import {flash} from '../helpers';
import {FormWithRating} from '../forms/formWithRating';

class VoteRating extends FormWithRating
{
    initListeners() {
        this.alreadyVoted = this.container.dataset['voted'];
        this.voteTooltipElement = this.container.querySelector('[data-vote="tooltip"]');

        super.initListeners();
    }

    initRatingField() {
        this.ratingFieldElement = this.container.querySelector('[data-field="rating"]');
        this.ratingCountFieldElement = this.container.querySelector('[data-field="rating-count"]');
        this.rating = new Rating(this.ratingFieldElement, () => {
            if (this.captchaField.classList.contains('is-none')) {
                this.submit();
            }

            this.rating.enable();
        });
    }

    showReCaptcha() {
        let reCaptcha = this.captchaField.querySelector('[data-form="re-captcha"]');

        if (reCaptcha) {
            this.captchaField.classList.remove('is-none');
            GoogleCaptcha.load(reCaptcha);
            reCaptcha.addEventListener('verified', () => this.submit());
        }
    }

    /** @param {Object} errors */
    renderErrors(errors) {
        GoogleCaptcha.reset();

        Object.entries(errors).forEach(([field, fieldErrors]) => {
            let firstErrorMessage = fieldErrors[0];

            if (!firstErrorMessage) {
                return;
            }

            if (field === 'g-recaptcha-response' && this.captchaField.classList.contains('is-none')) {
                this.showReCaptcha();
                return;
            }

            this.showTooltip(firstErrorMessage, '-red');
        });
    }

    /**
     * @param {String} message
     * @param {String} color
     */
    showTooltip(message, color = '-red') {
        if (this.voteTooltipElement) {
            this.voteTooltipElement.classList.add(color);
            this.voteTooltipElement.textContent = message;

            flash(this.voteTooltipElement);
        }
    }

    submit() {
        if (this.alreadyVoted) {
            this.showTooltip(this.voteTooltipElement.getAttribute('data-already-message'));
            return;
        }

        this.clearErrors();

        Api.post(this.action, this.data, (response) => {
            if (response.isFailure()) {
                return this.renderErrors(response.get('errors', {}));
            }

            if (response.hasMessage()) {
                this.showTooltip(response.getMessage(), '-green');
            }

            this.reset();

            let ratingCount = response.get('count', false);
            this.alreadyVoted = true;

            if (ratingCount) {
                this.ratingCountFieldElement.innerHTML = this.ratingCountFieldElement.innerHTML.replace(/\d+/, ratingCount);
            }
        });
    }
}

export {VoteRating};
